export function useHandleNotificationPress() {}
